module.exports = __webpack_public_path__ + "static/media/1017665.16f3c958.png";